import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDumbbell } from '@fortawesome/free-solid-svg-icons'
import tellMeLogo from '../../images/tellMeLogo.PNG'

const Tellme = () => (
    <div className='card p-3' style={{ fontSize: '.9rem' }}>
        <div className='row'>
            <div className=' col-12'>
                <img src={tellMeLogo} alt="tellme-logo" className='pb-1 mb-2 mr-3' style={{ width: '7rem' }}></img>
                <span className='mt-3 font-weight-bold'>Das Lehr-/Lerntool für den MSM 2.0</span>
            </div>
            <div className='col-12'>
                <p className='mt-2 p-0 '>Hier kannst du dein aktuelles Wissen zu den originalen MC-Fragen testen</p>
            </div>
            <a className='btn color-button-color ml-3 mt-2 px-4' style={{ position: 'relative', bottom: '0' }} target="blank" href='https://dsfz-online.charite.de/' >
                Trainieren mit<span className='ml-2'><FontAwesomeIcon icon={faDumbbell} /></span>
            </a>
        </div>
    </div>
)
export default Tellme
